"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var index_1 = require("./index");
var util_1 = require("../../utils/util");
var maximumRangeBoundaries = 2;
var selectTableHOC = function (multiSelectable) {
    if (multiSelectable === void 0) { multiSelectable = true; }
    return function (Component) {
        return /** @class */ (function (_super) {
            __extends(SelectTable, _super);
            function SelectTable(props) {
                var _this = _super.call(this, props) || this;
                _this.state = {
                    selectedIds: (props.selectedIds && props.selectedIds.slice()) || [],
                    lastSelectedId: undefined,
                    lastSelectedIdsFromProps: props.selectedIds && props.selectedIds.slice()
                };
                _this.onSelect = _this.onSelect.bind(_this);
                _this.onSelectAll = _this.onSelectAll.bind(_this);
                return _this;
            }
            SelectTable.prototype.componentWillReceiveProps = function (nextProps) {
                var lastSelectedIdsFromProps = this.state.lastSelectedIdsFromProps;
                var nextSelectedIds = nextProps.selectedIds;
                // Only sync state with selectedIds from props if next selectedIds are defined and they have changed
                if (nextSelectedIds &&
                    (!lastSelectedIdsFromProps ||
                        !util_1.arraysAreEqual(nextSelectedIds, lastSelectedIdsFromProps))) {
                    this.setState({
                        selectedIds: nextSelectedIds.slice(),
                        lastSelectedIdsFromProps: nextSelectedIds.slice()
                    });
                }
            };
            SelectTable.prototype.onSelect = function (id, shiftKey) {
                var e_1, _a;
                var _b = this.props, data = _b.data, rowId = _b.rowId, onSelectionChanged = _b.onSelectionChanged, onSelect = _b.onSelect;
                var selectedIds = this.state.selectedIds.slice();
                var lastSelectedId = this.state.lastSelectedId;
                if (!multiSelectable) {
                    // If multiselect is not enabled, only one row can be selectedIds at a time
                    selectedIds = selectedIds.includes(id) ? [] : [id];
                    // This is a range select if the following conditions are met:
                    //   1. Shift key is being held down
                    //   2. The ID has changed (if same ID as last selected, this is just a single select)
                    //   3. Last selected ID is contained within data (can't range select across pages because we only know current
                    //      page data)
                }
                else if (shiftKey &&
                    id !== lastSelectedId &&
                    data &&
                    data.map(function (row) { return rowId(row); }).includes(lastSelectedId)) {
                    var rangeBoundariesFound = 0;
                    // Keep same state as last selected row state (so if not included in selectedIds, that means it was deselected)
                    var deselect = !selectedIds.includes(lastSelectedId);
                    var _loop_1 = function (row) {
                        var loopRowId = rowId(row);
                        // Look for range start and end (each is a boundary - keep track of number of boundaries we have found)
                        if (loopRowId === lastSelectedId || loopRowId === id) {
                            ++rangeBoundariesFound;
                        }
                        // If within range (if we have found at least one boundary), modify row checked state
                        if (rangeBoundariesFound) {
                            if (deselect) {
                                selectedIds = selectedIds.filter(function (e) { return e !== loopRowId; });
                            }
                            else if (!selectedIds.includes(loopRowId)) {
                                // Don't include duplicates (from range start click)
                                selectedIds.push(loopRowId);
                            }
                        }
                        // If the end of the range was found, no need to keep iterating over rows (we also don't want to change
                        // selected state of rows beyond boundary)
                        if (rangeBoundariesFound === maximumRangeBoundaries) {
                            return "break";
                        }
                    };
                    try {
                        // Iterate over all of the data looking for the range, which has two bounds: last selected row and currently
                        // selected row (the row that triggered this onSelect handler)... note that we don't know which one we will
                        // encounter first, but we know that...
                        //   - ...once we encouter one boundary, we have found the start of the range
                        //   - ...once we encouter two boundaries, we have found the end of the range
                        // All rows within the start and end (inclusive) should be set to the same state (either selected or deselected)
                        for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                            var row = data_1_1.value;
                            var state_1 = _loop_1(row);
                            if (state_1 === "break")
                                break;
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                else if (selectedIds.includes(id)) {
                    selectedIds = selectedIds.filter(function (element) { return element !== id; });
                }
                else {
                    selectedIds.push(id);
                }
                this.setState({
                    selectedIds: selectedIds,
                    lastSelectedId: id
                }, function () {
                    onSelectionChanged && onSelectionChanged(selectedIds);
                    onSelect && onSelect(id, shiftKey);
                });
            };
            SelectTable.prototype.onSelectAll = function () {
                var _a = this.props, data = _a.data, rowId = _a.rowId, onSelectionChanged = _a.onSelectionChanged, onSelectAll = _a.onSelectAll;
                var selectedIds = this.state.selectedIds.slice();
                var dataIds = !data ? [] : data.map(function (row) { return rowId(row); });
                var allAreSelected = dataIds.every(function (id) {
                    return selectedIds.includes(id);
                });
                // Can't just do a wholesale rewrite of array, since we need to honor other pages (if items from other pages are
                // in the selectedIds array, they must be kept - only current page items can have selectedIds state modified)
                selectedIds = !allAreSelected
                    ? selectedIds.concat(dataIds.filter(function (id) { return !selectedIds.includes(id); }))
                    : selectedIds.filter(function (id) { return !dataIds.includes(id); });
                this.setState({
                    selectedIds: selectedIds
                }, function () {
                    onSelectionChanged && onSelectionChanged(selectedIds);
                    onSelectAll && onSelectAll();
                });
            };
            SelectTable.prototype.render = function () {
                return (React.createElement(Component, __assign({}, this.props, { selectedIds: this.state.selectedIds, onSelect: this.onSelect, onSelectAll: multiSelectable ? this.onSelectAll : undefined, "aria-multiselectable": multiSelectable })));
            };
            return SelectTable;
        }(React.Component));
    };
};
exports.singleSelectTableHOC = selectTableHOC(false);
exports.SingleSelectTable = exports.singleSelectTableHOC(index_1.Table);
exports.multiSelectTableHOC = selectTableHOC(true);
exports.MultiSelectTable = exports.multiSelectTableHOC(index_1.Table);
//# sourceMappingURL=SelectTable.js.map